module.exports = __webpack_public_path__ + "static/ArtworkBuilder-8dbebed98f32bfe80906b4563b0e7230.jpg";